<div class="list-flex">
  <div [ngStyle]="{width: '100%', clear: 'both', padding: '10px'}">
    <vip-paginator
      [paginator]="paginator"
      (pageChanged)="setPaginator($event)"
      [requesting]="requesting"
    ></vip-paginator>
  </div>
  @if (items) {
    <div class="dash-flex">
      <div [ngStyle]="{order: 1}">
        <div class="list-flex">
          <card-component [ngStyle]="{order: 1}" class="flex-filter">
            <card-content>
              <div [ngStyle]="{width: '100%', display: 'block'}">
                <h1 class="count"><i [className]="totalIcon"></i> {{ paginator.total }}</h1>
              </div>
              <div [ngStyle]="{width: '100%', display: 'block'}">
                @for (filter of filters; track filterTracker($index)) {
                  <list-filter
                    [filter]="filter"
                  ></list-filter>
                }
              </div>
              @if (actions) {
                <div [ngStyle]="{margin: '10px 0', width: '100%', display: 'block'}">
                  @for (action of actions; track actionTracker($index)) {
                    <list-action
                      [action]="action"
                    ></list-action>
                  }
                </div>
              }
              @if (queryModifiers) {
                <div [ngStyle]="{margin: '10px 0', width: '100%', display: 'block'}">
                  <query-modifiers
                    [queryModifiers]="queryModifiers"
                    (queryModifiersChange)="setQueryModifiers($event)"
                    [model]="model"
                  ></query-modifiers>
                </div>
              }
            </card-content>
          </card-component>
        </div>
      </div>
      <div [ngStyle]="{order: 2}">
        <div class="list-flex">
          @for (item of items; track itemTracker($index, item)) {
            <div class="flex-item">
              <list-item
                [item]="item"
                [actions]="itemActions"
                [descriptionParams]="descriptionParams"
                [deleteSelection]="deleteSelection"
                (deleteSelectionChecked)="handleToggle($event)"
              ></list-item>
            </div>
          }
        </div>
      </div>
    </div>
  }
</div>
